import { fstrRequest } from '@/helpers/request'

const api = {
	async getUser() {
		return await fstrRequest('user', { timeout: 10000 })
	},

	async updateUser(data) {
		return await fstrRequest('user', { method: 'put', data })
	},

	async generateLoginCode() {
		return await fstrRequest('user/login/code/generate', { method: 'post' })
	},

	async loginByCode(data) {
		return await fstrRequest('user/login/code', { method: 'post', data })
	},

	async sendConfirmEmail(data) {
		return await fstrRequest('user/login/code/send', { method: 'post', data })
	},

	async createMeasurement(data) {
		return await fstrRequest('user/measurements', { method: 'post', data })
	},

	async userCheck(data) {
		return await fstrRequest('user/check', { method: 'post', data })
	},

	async getUserFlags() {
		return await fstrRequest('user/flags', { method: 'get' })
	},

	async setUserFlags(data) {
		return await fstrRequest('user/flags', { method: 'post', data })
	}
}

export default api
